module.exports = __webpack_public_path__ + "img/blue-before-clouds.9cef39d7.png";